import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import PageIntro from '../components/PageIntro';

const CareNavigators: React.FC = () => {
  useEffect(() => { document.title = 'Care navigation — Haven Crest Health'; }, []);
  return (
    <main>
      <PageIntro
        eyebrow="Care navigation"
        title={<>The people <em>in your corner.</em></>}
        lede="A Haven Crest navigator is a real person assigned to you. They gather your records, explain what they say in plain language, coordinate between your doctors, find a specialist when you need a second opinion, and prep you for appointments. Like everything else here, it's free, and every decision stays yours."
      />
      <section className="section">
        <div className="wrap grid grid--3">
          <div className="card"><div className="card__ico">✎</div><h3>Plain-language summaries</h3><p>A short, readable account of what a report or chart actually says, and what's worth asking your doctor about.</p></div>
          <div className="card"><div className="card__ico card__ico--moss">⌕</div><h3>Finding the right doctor</h3><p>Help locating a specialist for a second opinion or a new primary doctor, with your records ready to share.</p></div>
          <div className="card"><div className="card__ico card__ico--accent">☑</div><h3>Appointment prep</h3><p>The questions to bring, the records to bring, and what to expect, so the visit goes further.</p></div>
        </div>
        <div className="wrap center" style={{ marginTop: '3rem' }}>
          <p className="lede">Ask for a navigator from inside your inbox, or email us and we'll introduce you.</p>
          <Link to="/contact" className="btn btn--ink">Get an advocate, free <span className="arrow">→</span></Link>
        </div>
      </section>
    </main>
  );
};

export default CareNavigators;
